import { gsap } from "gsap";
import lw from 'lottie-web'
import { ScrollTrigger } from "gsap/ScrollTrigger.js"
gsap.registerPlugin(ScrollTrigger)



// SDG
var sdgs = document.querySelectorAll('.for-generations__sdg__item');
if (sdgs) {

  sdgs.forEach(function (sdg) {
    console.log(sdg);

    var opacity = gsap.timeline({
      scrollTrigger:{
        trigger: sdg,
        scrub: 0.1,
        start: 'top center',
        end:'bottom center',
      }
    })
    .to(sdg, {
      opacity: 1,
      x: 0
    })

  }

}





// People Circles

var peopleCircle = document.querySelector('.hero__people');

if (peopleCircle) {

  gsap.to(".hero__people--1", {delay: 2.6, duration: 0.8, y: 0, opacity: 1, ease: "sine.inOut"});
  gsap.to(".hero__people--2", {delay: 0.4, duration: 0.8, y: 0, opacity: 1, ease: "sine.inOut"});
  gsap.to(".hero__people--3", {delay: 2, duration: 0.8, y: 0, opacity: 1, ease: "sine.inOut"});
  gsap.to(".hero__people--4", {delay: 1.8, duration: 0.8, y: 0, opacity: 1, ease: "sine.inOut"});
  gsap.to(".hero__people--5", {delay: 2.2, duration: 0.8, y: 0, opacity: 1, ease: "sine.inOut"});
  gsap.to(".hero__people--6", {delay: 1.2, duration: 0.8, y: 0, opacity: 1, ease: "sine.inOut"});
  gsap.to(".hero__people--7", {delay: 1, duration: 0.8, y: 0, opacity: 1, ease: "sine.inOut"});
  gsap.to(".hero__people--8", {delay: 1.6, duration: 0.8, y: 0, opacity: 1, ease: "sine.inOut"});
  gsap.to(".hero__people--9", {delay: 1.4, duration: 0.8, y: 0, opacity: 1, ease: "sine.inOut"});
  gsap.to(".hero__people--10", {delay: 1.4, duration: 0.8, y: 0, opacity: 1, ease: "sine.inOut"});
  gsap.to(".hero__people--11", {delay: 0.8, duration: 0.8, y: 0, opacity: 1, ease: "sine.inOut"});
  gsap.to(".hero__people--12", {delay: 0.6, duration: 0.8, y: 0, opacity: 1, ease: "sine.inOut"});
  gsap.to(".hero__people--12", {delay: 1.6, duration: 0.8, y: 0, opacity: 1, ease: "sine.inOut"});


  gsap.to(".hero__people--1", {
      duration: 8,
      y: -40,
      repeat:-1,
      yoyo: true,
      ease: "sine.inOut"
  });

  gsap.to(".hero__people--6", {
      duration: 6,
      y: -30,
      repeat:-1,
      yoyo: true,
      ease: "sine.inOut"
  });

  gsap.to(".hero__people--10", {
      duration: 5,
      y: -40,
      repeat:-1
      yoyo: true,
      ease: "sine.inOut"
  });


  gsap.to(".hero__people--5", {
      duration: 4,
      y: -20,
      repeat:-1,
      yoyo: true,
      ease: "sine.inOut"
  });

  gsap.to(".hero__people--13", {
      duration: 6,
      y: -30,
      repeat:-1,
      yoyo: true,
      ease: "sine.inOut"
  });

}



// Mental Health
var mental_trigger =  document.querySelector('.mental__reveal');
if (mental_trigger){
  var mental_magnifier =  document.querySelector('.magazine--mental-health-diseases #lupe');
  var opacity = gsap.timeline({
    scrollTrigger:{
      trigger: mental_trigger,
      scrub: 0.2,
      start: 'top +=300',
      end:'+=300',
    }
  })
  .to(mental_magnifier, {
    opacity: 1,
  })
}


// One Substance
var circle_trigger =  document.querySelector('.magazine--one-substance');
if (circle_trigger) {
  var circle_arrows_img =  document.querySelector('.figure--one-substance img');
  var rotate = gsap.timeline({
    scrollTrigger:{
      trigger: circle_trigger,
      scrub: 0.1,
      start: 'top center',
      end:'bottom center',
    }
  })
  .to(circle_arrows_img, {
    rotation:360*5,
    duration:1, ease:'none',
  })
}



// LOTTIES
if (document.querySelector('.lottie--heart')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--heart'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/HFrEF.json' // the path to the animation json
  });
}

if (document.querySelector('.lottie--heart-2')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--heart-2'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/HFpEF.json' // the path to the animation json
  });
}

if (document.querySelector('.lottie--blood')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--blood'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/blood.json' // the path to the animation json
  });  
}

if (document.querySelector('.lottie--ship')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--ship'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/ice-ship.json' // the path to the animation json
  });
}

if (document.querySelector('.lottie--contagion')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--contagion'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/Contagion.json' // the path to the animation json
  });
}


if (document.querySelector('.lottie--symptoms')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--symptoms'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/symptoms.json' // the path to the animation json
  });
}


if (document.querySelector('.lottie--bulp')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--bulp'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/boe_gb21_story06_lampe.json' // the path to the animation json
  });
}

if (document.querySelector('.lottie--gear')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--gear'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/boe_gb21_story06_zahnrad.json' // the path to the animation json
  });
}

if (document.querySelector('.lottie--virus')) {
  lw.loadAnimation({
    container: document.querySelector('.lottie--virus'), // the dom element that will contain the animation
    renderer: 'svg',
    loop: true,
    autoplay: true,
    path: '/assets/boe_gb21_story06_virus.json' // the path to the animation json
  });
}




// Cloud Computing
var cloud_slides =  document.querySelectorAll('.quantum-computing__slider');
if (cloud_slides) {
  cloud_slides.forEach(function (cloud_slide) {
    var cloud_dot =  cloud_slide.querySelector('.quantum-computing__slider__dot');
    ScrollTrigger.create({
      trigger: cloud_slide,
      start: "top center", 
      end: "bottom center",
      pin: cloud_dot,
      pinReparent: true
    });

  }
}





// Oncology
var onco_graphic =  document.querySelector('.oncology-graphic');
if (onco_graphic) {

  // init
  ScrollTrigger.create({
    trigger: onco_graphic,
    start: "top center",
    end: "bottom center",
    onEnter: () => onco_graphic.classList.add('is-active'),
  });

  // Button Sidebar
  var buttons = onco_graphic.querySelectorAll('.oncology-graphic__button');
  buttons.forEach(function (button) {
    button.addEventListener('click', function(event) {
      var button_id = button.dataset.button;
      buttons.forEach(function (button) {
        button.classList.remove('is-active');
      });      
      onco_graphic.querySelector('.oncology-graphic__button--' + button_id).classList.add('is-active');
      onco_graphic.classList.remove('slide-active--1');
      onco_graphic.classList.remove('slide-active--2');
      onco_graphic.classList.remove('slide-active--3');
      onco_graphic.classList.add('slide-active--' + button_id);
    }
  });

  var slideOne = onco_graphic.querySelector('.oncology-graphic__slide--1');
  var slideOneSwitch = slideOne.querySelector('.oncology-graphic__switch__button');
  var slideOneImgTwo = slideOne.querySelector('.oncology-graphic__img--2');
  var slideThree = onco_graphic.querySelector('.oncology-graphic__slide--3');
  var slideThreeSwitch = slideThree.querySelector('.oncology-graphic__switch__button');
  var slideThreeImgTwo = slideThree.querySelector('.oncology-graphic__img--2');

  slideOneSwitch.addEventListener('click', function(event) {
    if (slideOneSwitch.classList.contains('is-active')) {
      slideOneSwitch.classList.remove('is-active');
      slideOneImgTwo.classList.remove('is-active');
    } else {
      slideOneSwitch.classList.add('is-active');
      slideOneImgTwo.classList.add('is-active');
    }
    if (slideThreeSwitch.classList.contains('is-active')) {
      slideThreeSwitch.classList.remove('is-active');
      slideThreeImgTwo.classList.remove('is-active');
    } else {
      slideThreeSwitch.classList.add('is-active');
      slideThreeImgTwo.classList.add('is-active');
    }


  });

  // Slide 3
  slideThreeSwitch.addEventListener('click', function(event) {
    if (slideOneSwitch.classList.contains('is-active')) {
      slideOneSwitch.classList.remove('is-active');
      slideOneImgTwo.classList.remove('is-active');
    } else {
      slideOneSwitch.classList.add('is-active');
      slideOneImgTwo.classList.add('is-active');
    }

    if (slideThreeSwitch.classList.contains('is-active')) {
      slideThreeSwitch.classList.remove('is-active');
      slideThreeImgTwo.classList.remove('is-active');
    } else {
      slideThreeSwitch.classList.add('is-active');
      slideThreeImgTwo.classList.add('is-active');
    }
  });




}






